(function() { window.GUID_7c38ae61_3ab8_432a_80f5_99a50495a880 = { getGuid: function() { return "7c38ae61-3ab8-432a-80f5-99a50495a880"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-event-stat-compare",
                        extraEventNamespace: "innersection",
                        callback: (accordion, e) => {
                            var _a;
                            const $versusCard = accordion.$Container.find(".vs-card");
                            accordion.SetContentSticky($versusCard);
                            const $statsGroupHeaders = accordion.$Content.find(".cs-stats-group__header");
                            accordion.SetContentSticky($statsGroupHeaders, $versusCard);
                            CS.Controls.DropDown.Events.ListItemClicked({
                                selector: ".stats-compare__events-dropdown",
                                callback: (dropdown, dropdownEvent) => {
                                    const extraValues = dropdownEvent.data.extraValues;
                                    const url = extraValues.url;
                                    if (url != null) {
                                        accordion.Data.RefreshUrl = url;
                                    }
                                    accordion.RefreshContent();
                                },
                            });
                            const $gameTypeNameInput = accordion.$Content.find(`#EventStatCompareSectionViewModelGameTypeName-${accordion.ContentId}`);
                            const gameTypeName = (_a = $gameTypeNameInput.val()) !== null && _a !== void 0 ? _a : "";
                            const $emptyStateElement = accordion.$Content.find(`#EventStatCompareSectionViewModelNoData-${accordion.ContentId}`);
                            if ($emptyStateElement.length) {
                                if (gameTypeName.trim() === "") {
                                    $emptyStateElement.text(JSRess.These2OpponentsHaveNoCommonEvent);
                                }
                                else {
                                    $emptyStateElement.html(CS.Helper.formatString(JSRess.These2OpponentsHaveNoCommonEventInX, gameTypeName));
                                }
                            }
                            const $emptyStateForSelectedEventElement = accordion.$Content.find(`#EventStatCompareSectionViewModelNoDataForSelectedEvent-${accordion.ContentId}`);
                            if ($emptyStateForSelectedEventElement.length) {
                                if (gameTypeName.trim() === "") {
                                    $emptyStateForSelectedEventElement.text(JSRess.NoDataAvailableForThisEvent);
                                }
                                else {
                                    $emptyStateForSelectedEventElement.html(CS.Helper.formatString(JSRess.NoDataAvailableForThisEventInX, gameTypeName));
                                }
                            }
                            CS.Controls.DropDown.Events.ListItemClicked({
                                selector: "body",
                                childSelector: `#dropdown-stats-compare-in-event-events-${accordion.ContentId}`,
                                callback: (list, e) => {
                                    const { value, extraValues, innerText } = e.data;
                                    if (extraValues) {
                                        const { url } = extraValues;
                                        if (url) {
                                            accordion.Data.RefreshUrl = url;
                                            accordion.RefreshContent();
                                        }
                                    }
                                },
                            });
                            const showSelectedStatsGroup = (statsGroupId) => {
                                if (statsGroupId != "") {
                                    const $statsGroups = accordion.$Content.find(".cs-stats-group");
                                    if ($statsGroups.length) {
                                        $statsGroups.hide();
                                        const $selectedStatsGroup = $statsGroups.filter(`[data-stats-group-id="${statsGroupId}"]`);
                                        if ($selectedStatsGroup.length) {
                                            $selectedStatsGroup.show();
                                        }
                                    }
                                }
                            };
                            const $selectedStatsGroupIdHiddenInput = accordion.$Content.find(`#EventStatCompareSectionViewModelSelectedStatsGroupId-${accordion.ContentId}`);
                            let selectedStatsGroupId = "";
                            if ($selectedStatsGroupIdHiddenInput.length) {
                                selectedStatsGroupId = $selectedStatsGroupIdHiddenInput.val();
                                showSelectedStatsGroup(selectedStatsGroupId);
                            }
                            CS.Controls.DropDown.Events.ListItemClicked({
                                selector: "body",
                                childSelector: `#dropdown-stats-compare-in-event-stats-groups-${accordion.ContentId}`,
                                callback: (list, e) => {
                                    const { value, extraValues, innerText } = e.data;
                                    showSelectedStatsGroup(value);
                                    const $innerText = $("<div>").html(innerText);
                                    const selectedItemLabel = $innerText
                                        .find(".selected-item-label")
                                        .html();
                                    const $selectedItemLabel = $("<div>").html(selectedItemLabel);
                                    const rawText = $selectedItemLabel.text();
                                    const text = rawText.replace(/\n/g, "").trim();
                                    const $dropdownContainer = accordion.$Content.find(".dropdown-container");
                                    if ($dropdownContainer.length >= 2) {
                                        $($dropdownContainer[1]).find(".selected-item-label").text(text);
                                    }
                                },
                            });
                            const $dataInput = $(`#EventStatCompareSectionData-${accordion.ContentId}`);
                            if (!$dataInput.length)
                                return;
                            const rawData = $dataInput.val();
                            if (rawData == null ||
                                (typeof rawData === "string" && rawData.trim() === ""))
                                return;
                            const data = JSON.parse(rawData);
                            if (!data || data.ComparedStatsGroups.length === 0)
                                return;
                            const colors = CS.Helper.DataVisualizationHelper.getColors(2);
                            const $statsGroups = accordion.$Content.find(`.cs-stats-group`);
                            data.ComparedStatsGroups.forEach((statsGroup, statsGroupIndex) => {
                                const { StatsGroupId, Stats } = statsGroup;
                                if (!StatsGroupId || !Stats.length)
                                    return;
                                const $statsGroup = $statsGroups.filter(`[data-stats-group-id="${StatsGroupId}"]`);
                                if (!$statsGroup.length)
                                    return;
                                const $stats = $statsGroup.find(`.cs-stats-group__body .stat`);
                                if (!$stats.length)
                                    return;
                                const statFieldsToInclude = [
                                    "PlayedGames",
                                    "Average",
                                    "Vict",
                                    "Ero_For",
                                    "BreakAndRun",
                                    "TableRun",
                                    "TenOnBreak",
                                    "Vict_10_0",
                                    "WinsCount_10_0NotEro",
                                    "Efficacity",
                                    "Power_Fact",
                                    "Max_Consecutiv_Vict_SG",
                                    "Score",
                                ];
                                Stats.forEach((stat, statIndex) => {
                                    const $canvas = accordion.$Content.find(`#EventStatCompareSectionCanvas-${accordion.ContentId}-Stat-${statIndex}-StatsGroup-${StatsGroupId}`);
                                    if (!$canvas.length)
                                        return;
                                    if (statIndex >= $stats.length)
                                        return;
                                    const $stat = $($stats[statIndex]);
                                    const { Id, ValueA, ValueB, DisplayValueA, DisplayValueB, StatFieldId, } = stat;
                                    const shouldBeIncluded = statFieldsToInclude.includes(StatFieldId);
                                    if (!shouldBeIncluded || StatFieldId === "PlayedGames") {
                                        $canvas.remove();
                                        if (StatFieldId !== "PlayedGames")
                                            $stat.hide();
                                        return;
                                    }
                                    const parsedValueA = Number(CS.Helper.removeWhiteSpaces(ValueA));
                                    const parsedValueB = Number(CS.Helper.removeWhiteSpaces(ValueB));
                                    if (isNaN(parsedValueA) || isNaN(parsedValueB)) {
                                        $canvas.remove();
                                        $stat.hide();
                                        return;
                                    }
                                    EventStatCompareSection.renderChartV2({
                                        parsedValueA,
                                        parsedValueB,
                                        colors,
                                        $stat,
                                    });
                                });
                            });
                            const $allCanvas = accordion.$Content.find("canvas");
                            $allCanvas.each((index, canvas) => {
                                const $canvas = $(canvas);
                                const isWithinWallSectionBody = $canvas.closest(".stats-compare-section__body").length >= 1;
                                if (!isWithinWallSectionBody) {
                                    $canvas.remove();
                                }
                            });
                        },
                    });
                    let EventStatCompareSection;
                    (function (EventStatCompareSection) {
                        function renderChartV2({ parsedValueA, parsedValueB, colors, $stat, }) {
                            const chartContainerId = CS.Helper.generateRandomId();
                            const $chartContainer = $(`<div class="canvas-container"></div>`).css({
                                width: "100%",
                                padding: "8px 0 0 0",
                            });
                            $stat[0].append($chartContainer[0]);
                            $chartContainer.attr("id", chartContainerId);
                            const datapoints = [
                                {
                                    stackId: "0",
                                    seriesId: "A",
                                    value: parsedValueA,
                                    isStacked: false,
                                },
                                {
                                    stackId: "0",
                                    seriesId: "B",
                                    value: parsedValueB,
                                    isStacked: true,
                                },
                            ];
                            const comparedValueBarChart = new CS.Controls.ComparedValueBarChart({
                                colors: colors,
                                containerElementId: chartContainerId,
                                datapoints: datapoints,
                            });
                            comparedValueBarChart
                                .init()
                                .then(() => { })
                                .catch((error) => { });
                        }
                        EventStatCompareSection.renderChartV2 = renderChartV2;
                    })(EventStatCompareSection = WallSections.EventStatCompareSection || (WallSections.EventStatCompareSection = {}));
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=stats-compare.js.map
